export const signupFields = {
    // officer_title: {
    //     name: "officer_title",
    //     label: "Officer Title",
    //     required: false,
    // },
    // fax: {
    //     name: "fax",
    //     label: "Fax",
    //     required: false,
    // },
    // federal_tax_id: {
    //     name: "federal_tax_id",
    //     label: "Federal Tax ID",
    //     required: false,
    // },
    firstName: {
        name: "first_name",
        label: "First Name",
        required: true,
    },

    lastName: {
        name: "last_name",
        label: "Last Name",
        required: true,
    },
    email: {
        name: "email",
        label: "Email Address",
        required: true,
    },
    phone: {
        name: "phone_number",
        label: "Telephone",
        required: true,
    },
    password: {
        name: "password",
        label: "Password",
        required: true,
    },
    confirmPassword: {
        name: "confirm_password",
        label: "Confirm Password",
        required: true,
    },
}

export const confirmSignupFields = {
    userName: {
        name: "sub",
        label: "Username",
        required: true,
    },
    firstName: {
        name: "first_name",
        label: "First Name",
        required: true,
    },
    lastName: {
        name: "last_name",
        label: "Last Name",
        required: true,
    },
    email: {
        name: "email",
        label: "Email Address",
        required: true,
    },
    phone: {
        name: "phone_number",
        label: "Telephone",
        required: false,
    },
    password: {
        name: "password",
        label: "Password",
        required: true,
    },
    confirmationCode: {
        name: "code",
        label: "Confirmation Code",
        required: true,
    },
    // officer_title: {
    //     name: "officer_title",
    //     label: "Officer Title",
    //     required: false,
    // },
    // fax: {
    //     name: "fax",
    //     label: "Fax",
    //     required: false,
    // },
    // federal_tax_id: {
    //     name: "federal_tax_id",
    //     label: "Federal Tax ID",
    //     required: false,
    // },
}

export const groupOptions = {
    LIST_OWNER: 'List Owner',
    BROKER: 'Broker'
}
